import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.285 20.13c-1.505 0-2.724-1.22-2.724-2.724 0-1.307.92-2.398 2.147-2.663.029-.005.057-.01.085-.016 1.228-.265 2.148-1.356 2.148-2.663 0-.05-.002-.111-.004-.16 1.54.646 2.621 2.178 2.621 3.953 0 2.36-1.913 4.273-4.273 4.273zm7.952-5.524c-.056-1.37-.502-2.639-1.23-3.699-.413-.601-.955-1.098-1.558-1.51-.294-.201-.573-.424-.833-.666-1.382-1.287-2.248-3.122-2.248-5.16 0-.54.063-1.066.178-1.571-1.788 1.278-2.955 3.371-2.955 5.737 0 .098.003.194.007.291.014.351.054.696.118 1.032-.019.75-.616 1.348-1.354 1.348-.489 0-.916-.264-1.149-.656-.19-.639-.293-1.314-.293-2.015 0-.224.011-.447.032-.666C6.165 8.815 5 11.67 5 14.895 5.035 18.819 8.216 22 12.14 22c3.923 0 7.104-3.181 7.104-7.105 0-.097-.003-.193-.007-.289z",
    fill: "currentColor"
  }));
});